export default "__VITE_ASSET__Dd8Bvbc$__ 100w";